import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Confirm, Grid, Loader } from 'semantic-ui-react';
import moment from 'moment';
import { leadsActions } from '../../actions/leads.actions';

class LeadsShowScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      name: '',
      submitted: false,
    };
  }

  handleCancel = () => this.setState({ open: false });

  deleteShow = () => this.setState({ open: true });

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(leadsActions.getById(match.params.id));
  }

  deleteById() {
    const { match, dispatch } = this.props;

    dispatch(leadsActions.deleteById(match.params.id)).then(() =>
      this.props.history.push('/leads'),
    );
  }

  editById() {
    const { match } = this.props;

    this.props.history.push(`/leads/${match.params.id}/edit`);
  }

  render() {
    const { leads, loading } = this.props;
    const { open } = this.state;

    return (
      <Fragment>
        <Confirm
          content="Deseja remover esse item?"
          open={open}
          onCancel={this.handleCancel}
          onConfirm={() => this.deleteById()}
        />
        <Loader active={loading} />
        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={10} computer={10}>
            <h1>Visualização</h1>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={6} computer={6} textAlign="right">
            <Button icon="edit outline" title="Editar" onClick={() => this.editById()} />
            <Button icon="trash alternate outline" title="Remover" onClick={this.deleteShow} />
          </Grid.Column>
        </Grid>
        <div className="container-inner">
          <h4>Id: </h4>
          {leads.id}
          <h4>Status: </h4>
          {leads.status?.name}
          <h4>Título: </h4>
          {leads.title || '-'}
          <h4>Comentários: </h4>
          {leads.notes || '-'}
          <h4>Criado em: </h4>
          {moment(leads.created_at).format('DD/MM/YYYY')}
          <h4>Atualizado em: </h4>
          {moment(leads.updated_at).format('DD/MM/YYYY')}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { leads } = state;
  return {
    leads,
    loading: leads.loading || false,
  };
}

const connectedLeadsShowScreen = connect(mapStateToProps)(LeadsShowScreen);
export { connectedLeadsShowScreen as LeadsShowScreen };
